import React, { useState } from 'react';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { useSelectedRows } from '../tabla/SelectedRowsContext';
import DeleteIcon from '@mui/icons-material/Delete';
import '../../estilo/App.css';
import ConfirmDeleteModal from '../modales/DeleteModal';
import axiosInstancePromise from '../../general/axiosConfig';

const BtnEliminar = ({table, funcSenal, rowid, rowdb}) => {
  const { selectedRows = [] } = useSelectedRows() || {};
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const handleDelete = (user) => {
    setOpenConfirmModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const objetivos = selectedRows.map((row) => row.id);
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.delete(`/gestion-eliminar-general/${table}`,
        {
            data: { 
              ids: objetivos,
              rows: selectedRows,
            },
        }
      );
      setOpenConfirmModal(false);
      funcSenal();
    } catch (error) {
      console.error('Error al eliminar registros:', error);
    }
  };

  const handleConfirmDelete2 = async (id, db_name) => {
      try {
          const axiosInstance = await axiosInstancePromise;
          await axiosInstance.delete(`/eliminar-cliente`, {
              headers: { "Content-Type": "application/json" },
              data: { id:id, db_name:db_name }
          });
        funcSenal();
          
      } catch (error) {
        console.error("Error al eliminar: " + error.response?.data?.error);
      }
  };

  if (table === 'superus') {
    return (
      <>
        <Tooltip title="Eliminar" arrow>
          <IconButton onClick={handleDelete}><DeleteIcon /></IconButton>
        </Tooltip>    
        <ConfirmDeleteModal 
          open={openConfirmModal} 
          handleClose={() => setOpenConfirmModal(false)} 
          handleConfirm={() => handleConfirmDelete2(rowid, rowdb)} 
          estado={true}
        />
      </>
    );
  } else {
    return (
      <Box>
        <Box>
          <Button sx={{mt:2}} variant="outlined" onClick={handleDelete} disabled={selectedRows.length === 0} >
            Eliminar
          </Button>
        </Box>
        <ConfirmDeleteModal open={openConfirmModal} handleClose={() => setOpenConfirmModal(false)} handleConfirm={handleConfirmDelete} />
      </Box>
    );
  }
};

export default BtnEliminar;
